export const CustomDocsUpdateStageType = {
  SELECT_MODE: "select",
  SUBMIT: "submit",
  FINISH: "finish",
} as const;
export type CustomDocsUpdateStageType =
  (typeof CustomDocsUpdateStageType)[keyof typeof CustomDocsUpdateStageType];
